import { useModel, DisabledPrompt } from "@bcm-dev/bcms-vite";
import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import ContentSubheaderView from 'components/shared/views/ContentSubheaderView';
import PageContentView from 'components/shared/views/PageContentView';
import React from 'react';
import "./styles.css";
import { useEffect } from "react";
/**
 * @function MyFiancesPage
 * @return {React.Component}
 * @note - Branding for this page is being added to the window object so captures can utilize the set value in state code
 * @exported true
 * @description The main component for MyFiancesPage
 */
export default function MyFiancesPageExternal(props) {
  // Branding options needed for captures
  const options = useModel().branding.options;

  const hasPFM21Course = options.pfm21_courseID_abi22 !== null && options.pfm21_courseID_abi22.length > 0;
  const hasPFM25Course = options.pfm25_courseID_abi22 !== null && options.pfm25_courseID_abi22.length > 0;

  const demo = hasPFM25Course ? "PFM25" : (hasPFM21Course ? "PFM21" : null);
  
  //window.BRANDING = demo =="PFM21"?{ "pfm21_abi22" : options.pfm21_abi22 }:{ "pfm25_abi22" : options.pfm25_abi22 };

  window.BRANDING = { "pfm21_abi22": options.pfm21_abi22 };

  const subheaderText = options.myfinancess_subheader_abi22;
  const hasSubheaderText = subheaderText ? true : false;

  const mabiBranding = window.mabi23Branding;
  const option = mabiBranding
    ? mabiBranding.options.integrated_page_header_mabi23
    : options.integrated_page_header_abi22;
  const showHeader = option !== "false";
  const openMyFinances = () => {
    if (!demo) return;
    window.open("#/ExternalDemoPage", "externalDemoPage");
  };
  const reloadButton = (
    <button
      type="button"
      className="ui-button secondary-button reload-button"
      data-point="reload_pfm_button"
      onClick={() => window.open("#/externalDemoPage", "externalDemoPage")}
    >
      <span>Reload My Finances</span>
    </button>
  );
  useEffect(() => {
    if(demo){
      window.open("#/externalDemoPage", "externalDemoPage")
    }
    },[]);
  return (
    <PageContainer className="my-finances-page integrated-product-page" ignoreTrigger={ true }>
      <PageContentView title="My Finances">
        <CenterContentContainer>
          { showHeader && <ContentHeaderView text="My Finances"/> }

          { hasSubheaderText && <ContentSubheaderView text={ subheaderText } /> }
          <div className="disclaimer-message flex-container flex-horizontal justify-left">
            This page opens in a new window. If your web browser has a pop-blocker, please disable it and click Reload to reopen the window.
          
          </div>
          <div className="button-container flex-container flex-vertical">
          {demo ? reloadButton : <DisabledPrompt>{reloadButton}</DisabledPrompt>}
          </div>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}
